import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerUser, updateUser } from '../api/usersApi';
import { getProfesionLabel, getProfesionValue } from '../model/userConstants';

export const useCreateUserForm = ({ user, onSuccess } = {}) => {
  const navigate = useNavigate();
  const isEdit = Boolean(user);
  const [nombre, setNombre] = useState(user?.firstname ?? '');
  const [apellidos, setApellidos] = useState(user?.lastname ?? '');
  const [usuario, setUsuario] = useState(user?.username ?? '');
  const [email, setEmail] = useState(user?.email ?? '');
  const [password, setPassword] = useState('');
  const [profesional, setProfesional] = useState(user ? getProfesionLabel(user.profesional) : '');
  const [role, setRole] = useState(user?.role ?? 'SANITARIO');
  const [openGood, setOpenGood] = useState(false);
  const [openBad, setOpenBad] = useState(false);
  const [errors, setErrors] = useState({
    nombre: '',
    apellidos: '',
    usuario: '',
    password: '',
    email: '',
  });

  const validate = () => {
    const passwordProvided = password.trim() !== '';
    const nextErrors = {
      nombre: /\d/.test(nombre) || nombre.trim() === '' ? 'El nombre no puede tener numeros' : '',
      apellidos: /\d/.test(apellidos) || apellidos.trim() === '' ? 'Los apellidos no pueden tener numeros' : '',
      usuario: /\s/.test(usuario) || usuario.trim() === '' ? 'El usuario no puede tener espacios en blanco' : '',
      password: (isEdit && !passwordProvided) ? '' : (password.length < 8 || password.length > 72 ? 'La contraseña debe tener entre 8 y 72 caracteres' : ''),
      email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email) ? '' : 'Introduce un email valido',
    };
    setErrors(nextErrors);
    return !Object.values(nextErrors).some(Boolean);
  };

  const handleSave = async () => {
    if (!validate()) {
      setOpenBad(true);
      return;
    }

    try {
      if (isEdit) {
        const payload = {
          username: usuario,
          firstname: nombre,
          lastname: apellidos,
          email,
          profesional: getProfesionValue(profesional),
        };
        if (password.trim() !== '') payload.password = password;
        await updateUser({ userId: user.id, payload });
      } else {
        await registerUser({
          username: usuario,
          firstname: nombre,
          lastname: apellidos,
          email,
          password,
          profesional: getProfesionValue(profesional),
          role,
        });
      }
      setOpenGood(true);
      setTimeout(() => { (onSuccess || (() => navigate('/homeAdmin')))(); }, 1200);
    } catch (error) {
      console.error(`Error al ${isEdit ? 'actualizar' : 'crear'} usuario:`, error);
      setOpenBad(true);
    }
  };

  return {
    isEdit,
    nombre, setNombre,
    apellidos, setApellidos,
    usuario, setUsuario,
    email, setEmail,
    password, setPassword,
    profesional, setProfesional,
    role, setRole,
    openGood, setOpenGood,
    openBad, setOpenBad,
    errors,
    handleSave,
  };
};
